<script setup>
import { Head } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'

import termsHtml from '../../../legal/terms.de.html?raw'

const { t, locale } = useI18n()
</script>

<template>
  <Head :title="t('title')" />
  <Card class="w-full !ring-8 ring-white/20" :dt="{ body: { padding: '4rem', gap: '2rem' }, root: { shadow: 'none' } }">
    <template #content>
      <div class="flex flex-col gap-4">
        <Message v-if="locale !== 'de'" severity="warn" icon="pi pi-exclamation-circle">
          {{ t('language_notice') }}
        </Message>
        <div class="terms-content" v-html="termsHtml"></div>
      </div>
    </template>
  </Card>
</template>

<style scoped>
@reference "../../../css/app.css";

.terms-content :deep(h1) {
  @apply text-surface-900 text-2xl font-semibold;
}

.terms-content :deep(h2) {
  @apply text-surface-900 mt-8 text-lg font-semibold;
}

.terms-content :deep(p) {
  @apply text-surface-700 text-base leading-6;
}

.terms-content :deep(ul),
.terms-content :deep(ol) {
  @apply text-surface-700 my-4 space-y-2 pl-6 text-base;
}

.terms-content :deep(ul) {
  @apply list-disc;
}

.terms-content :deep(ol) {
  @apply list-decimal;
}

.terms-content :deep(li) {
  @apply leading-6;
}

.terms-content :deep(a) {
  @apply text-action underline;
}
</style>

<i18n>
{
    "en": {
        "title": "Platform Terms of Use",
        "language_notice": "This document is only available in German. If you need a translation, please contact us."
    },
    "de": {
        "title": "Allgemeine Plattformnutzungsbedingungen (AGB)",
        "language_notice": "Dieses Dokument ist nur auf Deutsch verfügbar. Wenn Sie eine Übersetzung benötigen, kontaktieren Sie uns bitte."
    }
}
</i18n>
